import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { exists, isValidArray } from '../../../helpers';
import Text from '../Text';
import Styles from './OptionsInput.styles';

const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore
const SelectWrapper = styled.div`${Styles.selectWrapper};`; // prettier-ignore
const Select = styled.select`${Styles.select}`; // prettier-ignore
const Input = styled.input`${Styles.input}`;
const SelectArrow = styled.div`${Styles.selectArrow};`; // prettier-ignore
const Name = styled(Text).attrs({ bold: true })`${Styles.name}`; // prettier-ignore

/**
 * OptionsInput component
 * @param {string} className - modifier class
 * @param {string} defaultValue - default valu for select box
 * @param {string} name - input's name
 * @param {Array} options - input's options
 * @param {string} color - optional color
 * @param {bool} isSorting - true if its a sorting select
 * @returns {?JSX}
 */
const OptionsInput = ({
  className, name, options, onChange, value, hasBlackTheme, color, isSorting, calendar, min, textColor, max, inputName, status, labelPosition = 'bottom', style,
}) => {
  if (!exists(name) || !isValidArray(options)) return null;

  const getColor = (status) => {
    return status == 1 ? 'green' : 'red';
  }

  return (
    <Wrapper className={className} hasBlackTheme={hasBlackTheme} isSorting={isSorting}>
      {labelPosition === 'top' && !isSorting ? <Name style={{ color: '#272031', fontFamily: 'Gotham-Book', fontSize: 14, marginBottom: 12 }}>{name}</Name> : null}
      <SelectWrapper>
        {!calendar && (
        <Select className={hasBlackTheme ? 'cbx-regular' : 'cbx-bold'} style={style} onChange={onChange} value={value} hasBlackTheme={hasBlackTheme} isSorting={isSorting}>
          {options.map(option => (
            <option value={option.value} key={`inputValue${name}${option.value}`}>
              {option.name}
            </option>
          ))}
        </Select>)}
        {calendar && (
          <Input name={inputName} type="date" textColor={textColor} className={hasBlackTheme ? 'cbx-regular' : 'cbx-bold'} onChange={onChange} value={value} min={min} max={max} hasBlackTheme={hasBlackTheme} isSorting={isSorting} />
        )}
        {!calendar && <SelectArrow hasBlackTheme={hasBlackTheme} isSorting={isSorting} style={{ bottom: labelPosition === 'top' ? 14 : undefined }} />}
      </SelectWrapper>
      {labelPosition === 'bottom' && !isSorting ? <Name color={status ? getColor(status) : color}>{name}</Name> : null}
    </Wrapper>
  );
};

OptionsInput.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
  hasBlackTheme: PropTypes.bool,
  isSorting: PropTypes.bool,
  color: PropTypes.string,
  textColor: PropTypes.string,
  calendar: PropTypes.bool,
  min: PropTypes.string,
  max: PropTypes.string,
  inputName: PropTypes.string
};

export default OptionsInput;
